module.exports = __webpack_public_path__ + "static/media/grin-hearts.dd2366e9.svg";